import PageSelect from './PageSelect'

class Bridge {

	constructor(bridgeE) {
		const pageId = (value => {
			if (/^[1-9][0-9]*$/.test(value)) return parseInt(value, 10)
			return null
		})(bridgeE.value)

		this.bridgeE = bridgeE
		bridgeE.setAttribute('type', 'hidden')

		this.container = this.createContainer()
		this.app = new Vue({
			data() {
				return { pageId }
			},
			el: this.container,
			components: {
				PageSelect
			},
			template: `<PageSelect v-model="pageId" />`,
			watch: {
				pageId() {
					bridgeE.value = this.pageId
				}
			}
		})
	}

	createContainer() {
		const container = document.createElement('div')
		const { bridgeE } = this
		bridgeE.parentNode.insertBefore(container, bridgeE)
		return container
	}
}

export default Bridge
